import styled from 'styled-components';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

interface TrialProps {
  readonly trialAnalysisLeft: number;
}

const TrialInfoContainer = styled.div`
  align-self: flex-end;
  padding-top: 20px;
`;

const TrialTitle = styled.span`
  color: ${p => p.theme.color.battleshipGrey};
  font-size: ${p => p.theme.font.size.small};
`;

export const TrialInfoComponent = (props: TrialProps) => {
  return (
    <TrialInfoContainer>
      <TrialTitle>
        <FormattedMessage
          id={`components.TrialInfo`}
          values={{
            n: props.trialAnalysisLeft,
          }}
        />
      </TrialTitle>
    </TrialInfoContainer>
  );
};



// WEBPACK FOOTER //
// ./src/components/TrialInfo/index.tsx